"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAuthenticationConfig = void 0;
var buildAuthenticationConfig = function (options) {
    var publishableKey = options.publishableKey, authenticationAppBaseUrl = options.authenticationAppBaseUrl;
    if (options.customDomainEnabled) {
        var currentHostname = options.currentHostname;
        var isSatellite = !currentHostname.endsWith(options.primaryHostname);
        var domain = currentHostname;
        var proxyUrl = isSatellite ? "https://".concat(currentHostname, "/__clerk") : undefined;
        if (options.environment === "production") {
            return {
                publishableKey: publishableKey,
                authenticationAppBaseUrl: authenticationAppBaseUrl,
                isSatellite: isSatellite,
                proxyUrl: proxyUrl,
            };
        }
        else {
            return {
                publishableKey: publishableKey,
                authenticationAppBaseUrl: authenticationAppBaseUrl,
                signInUrl: "".concat(options.authenticationAppBaseUrl, "/debug"),
                isSatellite: isSatellite,
                domain: domain,
            };
        }
    }
    else {
        return {
            publishableKey: publishableKey,
            authenticationAppBaseUrl: authenticationAppBaseUrl,
        };
    }
};
exports.buildAuthenticationConfig = buildAuthenticationConfig;
